module.exports = __webpack_public_path__ + "img/gown.919b5b29.png";